import { FilesUpload, FileUpload } from "@/eworkitComponents";
import { withFormikField } from "@/formikComponents";

export const FormikFileUpload = withFormikField(FileUpload);
export const FormikFilesUpload = withFormikField(FilesUpload);
